import React, { useContext, useState } from 'react';
import LoginHeader from '../../components/Headers/LoginHeader';
import LoginFooter from '../../components/Footers/LoginFooter';
import ScheduleTemplateEdit from '../../components/ScheduleTemplateEdit';
import { UserContext } from '../../context/User';
import AdminHeader from '../../components/Headers/AdminHeader';

const ScheduleTemplateEditPage = () => {
  const { user } = useContext(UserContext);
  const role = user && user.roles && user.roles[0].role_description;
  const [trigger, setTrigger] = useState(false);

  return (
    <>  
      {role === "admin" ? <AdminHeader trigger={trigger} /> : <LoginHeader trigger={trigger} />}
      <main>
        <ScheduleTemplateEdit 
          setTrigger={setTrigger}
          trigger={trigger}
        />
        
      </main>
      <LoginFooter />
    </>
  )
}

export default ScheduleTemplateEditPage;
